var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStableDiaryViewEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stable_diary_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: -0.22,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stable_diary_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.31.93a16.94,16.94,0,0,0-17,16.87V428.65a16.94,16.94,0,0,0,17,16.87H582.19a16.94,16.94,0,0,0,17-16.87V17.8a16.94,16.94,0,0,0-17-16.87",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.24,
    y: 77.07,
    width: 380.92,
    height: 444.6,
    rx: 16.79,
    fill: "#83d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,271.14V582.88a17,17,0,0,1-17.26,16.72H17.74A17,17,0,0,1,.49,582.88V171.72A17,17,0,0,1,17.74,155H261.53a18,18,0,0,1,5.85,1L379.86,264.21A16.29,16.29,0,0,1,381.41,271.14Z",
    fill: "#ccf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.64,263.21h-95a17.2,17.2,0,0,1-17.43-17V155Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9,
    y: 371.68,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.94 1.41) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.02,
    y: 517.27,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.04 0.94) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.34,
    y: 299.13,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.39 1.41) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.46,
    y: 444.23,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.48 1.42) rotate(-0.43)",
    fill: "#00a0df"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiaryViewEntries);
export default __webpack_public_path__ + "static/media/stable_diary_view_entries.5075042131bb867bc3481ff98e836603.svg";
export { ForwardRef as ReactComponent };